// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"errorList_errorWrapper__3dBTq"};